import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import services from '../../../services';
import AboutOptions from './AboutOptions';
import ContactData from './ContactData';
import './Navbar.css';
import ResourceOptions from './ResourceOptions';
import ServiceOptions from './ServiceOptions';
import { useTranslation } from 'react-i18next';

function Navbar(props) {
  const navbar = useRef();
  const [mobileNav, setMobileNav] = useState(false);
  const [searchBar, setSearchBar] = useState(false);
  const token = localStorage.getItem('kss_token');
  const [user, setUser] = useState('');

  // translation

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const LangChangeHandler = (event) => {
    i18n.changeLanguage(event.target.value);
    props.lang(event.target.value);
  };

  // end of translation
  useEffect(() => {
    if (token) {
      axios
        .get(`https://account-testing-be.herokuapp.com/users/single_user`, {
          headers: {
            token: token,
          },
        })
        .then((res) => {
          setUser(res.data);
        })
        .catch((err) => {
          window.alert('some error occured please check console');
          console.log(err);
        });
    }
  }, [token]);

  const handleClick = (e) => {
    if (!navbar.current?.contains(e.target)) {
      setMobileNav(false);
    }
  };
  window.addEventListener('mousedown', handleClick, false);

  window.addEventListener('scroll', () => {
    setMobileNav(false);
  });

  function navigateTo(id) {
    if (document.getElementById(id)) {
      let offsetTop = document.getElementById(id).offsetTop;
      window.scroll({
        top: offsetTop - 100,
        behavior: 'smooth',
      });
    }
  }
  let history = useHistory();
  function goToService(service) {
    const url = `/service?id=${service.id}`;
    history.push(url);
  }

  return (
    <>
      <nav
        className="navbar navbar-expand-md fixed-top py-md-0 px-1"
        id="navbar"
      >
        <div className="container px-0">
          <a className="navbar-brand mr-0 py-0" href="/">
            {t('sections-NavBar-NavBar-heading')}
          </a>

          <ul className="navbar-nav d-flex d-md-none flex-row align-items-center">
            <li className="nav-item pl-4 searchBtn ">
              <i
                className="fa fa-search "
                onClick={() => {
                  setSearchBar(true);
                }}
              ></i>
            </li>
            <li className="nav-item searchBtn ml-3">
              <i
                className="fa fa-bars mr-2"
                onClick={() => {
                  setMobileNav(true);
                }}
              ></i>
            </li>
          </ul>

          {/* Collapsible Desktop Nav  */}
          <div
            className="collapse navbar-collapse d-none d-lg-block"
            id="navbarScroll"
          >
            <ul className="navbar-nav ml-auto my-lg-0  d-flex align-items-center">
              <li className="nav-item mx-2 nav-item-service">
                <a className="nav-link nav-link-ltr" href="/">
                  {/* Service */}
                  {t('sections-NavBar-NavBar-Service')}
                  <i className="fa fa-chevron-down mx-1"></i>
                </a>
                <ServiceOptions />
              </li>

              <li className="nav-item mx-2 nav-item-resource">
                <a className="nav-link nav-link-ltr" href="/">
                  {t('sections-NavBar-NavBar-Resource')}
                  <i className="fa fa-chevron-down mx-1"></i>
                </a>
                <ResourceOptions navigateTo={navigateTo} />
              </li>

              <li className="nav-item mx-2 nav-item-about position-relative">
                <a className="nav-link nav-link-ltr" href="/">
                  {t('sections-NavBar-NavBar-About')}
                  <i className="fa fa-chevron-down mx-1"></i>
                </a>
                <AboutOptions navigateTo={navigateTo} />
              </li>

              <li className="nav-item d-flex align-items-center ml-2 mr-3 mr-lg-4 py-2">
                {user ? (
                  <>
                    <p className="my-0 text-white mr-3 text-decoration-underlined">
                      {user.name}
                    </p>
                    <button
                      className="btn clientPortalBtn"
                      onClick={() => {
                        localStorage.removeItem('kss_token');
                        setUser('');
                        window.location.reload();
                      }}
                    >
                      {t('sections-NavBar-NavBar-Logout')}
                    </button>
                  </>
                ) : (
                  <button
                    className="btn clientPortalBtn"
                    onClick={() => {
                      history.push(`/login`);
                    }}
                  >
                    {t('sections-NavBar-NavBar-Login')}
                  </button>
                )}
              </li>

              {/* for translation */}
              <li className="nav-item mx-2 nav-item-service">
                <select name="language" onChange={LangChangeHandler}>
                  <option value="en">English</option>
                  <option value="fr">French</option>
                </select>
              </li>
              {/* end of translation option */}

              <li className="nav-item pl-3 pl-lg-4 searchBtn">
                <i
                  className="fa fa-search "
                  onClick={() => {
                    setSearchBar(true);
                  }}
                ></i>
              </li>
            </ul>
          </div>

          {/* Mobile Nav */}
          <div
            className={
              'mobile-nav container d-md-none ' +
              (mobileNav ? 'mobile-nav-show' : 'd-none')
            }
            ref={navbar}
          >
            <div
              className="accordion mobile-nav-accordian"
              id="mobile-nav-accordian"
            >
              <button
                className="btn btn-link btn-block text-left px-0"
                type="button"
                data-toggle="collapse"
                data-target="#collapseServices"
                aria-expanded="true"
                aria-controls="collapseServices"
              >
                {t('sections-NavBar-NavBar-Service')}{' '}
                <i className="fa fa-chevron-down ml-1"></i>
              </button>

              <div
                id="collapseServices"
                className="collapse show"
                data-parent="#mobile-nav-accordian"
              >
                <ul className="navbar-nav">
                  {services.map((service, i) => {
                    return (
                      <li
                        key={i}
                        className="nav-item my-1"
                        onClick={() => goToService(service)}
                      >
                        {service.title}
                      </li>
                    );
                  })}
                </ul>
              </div>

              <button
                className="btn btn-link btn-block text-left px-0 collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseResource"
                aria-expanded="true"
                aria-controls="collapseResource"
              >
                {t('sections-NavBar-NavBar-Resource')}{' '}
                <i className="fa fa-chevron-down ml-1"></i>
              </button>

              <div
                id="collapseResource"
                className="collapse"
                data-parent="#mobile-nav-accordian"
              >
                <ul className="navbar-nav">
                  <li
                    className="nav-item my-1"
                    onClick={() => {
                      navigateTo('formSection');
                    }}
                  >
                    {t('sections-NavBar-ResourceOptions-Forms')}
                  </li>
                  <li
                    className="nav-item my-1"
                    onClick={() => {
                      navigateTo('calculatorsSection');
                    }}
                  >
                    {t('sections-NavBar-ResourceOptions-Calculator')}
                  </li>
                  <li
                    className="nav-item my-1"
                    onClick={() => {
                      navigateTo('videoGallery');
                    }}
                  >
                    {t('sections-NavBar-ResourceOptions-Video')}
                  </li>
                  <li
                    className="nav-item my-1"
                    onClick={() => {
                      navigateTo('Blogarea');
                    }}
                  >
                    {t('sections-NavBar-ResourceOptions-Blog')}
                  </li>
                  {/* <li className="nav-item my-1">Case Study</li> */}
                </ul>
              </div>

              <button
                className="btn btn-link btn-block text-left px-0 collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseAbout"
                aria-expanded="false"
                aria-controls="collapseAbout"
              >
                {t('sections-NavBar-NavBar-About')}{' '}
                <i className="fa fa-chevron-down ml-1"></i>
              </button>

              <div
                id="collapseAbout"
                className="collapse"
                data-parent="#mobile-nav-accordian"
              >
                <ul className="navbar-nav">
                  <li
                    className="nav-item my-1"
                    onClick={() => {
                      navigateTo('aboutSection');
                    }}
                  >
                    {t('sections-NavBar-AboutOptions-Team')}
                  </li>
                  <li
                    className="nav-item my-1"
                    onClick={() => {
                      navigateTo('testimonials');
                    }}
                  >
                    {t('sections-NavBar-AboutOptions-Testimonial')}
                  </li>
                  <li
                    className="nav-item my-1"
                    onClick={() => {
                      navigateTo('clients');
                    }}
                  >
                    {t('sections-NavBar-AboutOptions-Clients')}
                  </li>
                  <li
                    className="nav-item my-1"
                    onClick={() => {
                      navigateTo('footer');
                    }}
                  >
                    {t('sections-NavBar-AboutOptions-Contact')}
                  </li>
                  <li className="nav-item my-1">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`tel:${ContactData.phone}`}
                    >
                      {' '}
                      <i className="mx-2 fa fa-phone"></i>
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        window.matchMedia('(max-width: 786px)').matches
                          ? `mailto:${ContactData.mail}`
                          : `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${ContactData.mail}`
                      }
                    >
                      {' '}
                      <i className="mx-2 fa fa-envelope"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row w-100 mx-0 mt-2 justify-content-center">
              <button
                className="btn clientPortalBtn"
                onClick={() => {
                  window.location.replace(`https://account-kss.web.app/login`);
                }}
              >
                {t('sections-NavBar-NavBar-Login')}
              </button>
            </div>
          </div>

          <div className={'searchBar ' + (searchBar ? 'show-searchBar' : '')}>
            <input type="text" placeholder="Search ..." />
            <i
              className="bx bx-x "
              onClick={() => {
                setSearchBar(false);
              }}
            ></i>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
